import React from "react";
import { NextPage } from "./components";
const NextPageContainer = React.memo(({ onSave, handlerClick, showType }) => {
    const handlerSave = (time) => {
        onSave(showType, time);
    };
    return (React.createElement(NextPage, { name: showType, handlerClick: handlerClick, onSave: handlerSave }));
});
export default NextPageContainer;
